<template>
  <header-sub-component v-if="$store.state.auth?.oidc?.user" />
    <section class="lras mt-3">
        <div class="lras__list">
            <template v-if="isLoading">
                <p>Подождите... Идет загрузка данных</p>
            </template>
            <template v-else-if="!items">
                <p>Ничего не найдено</p>
            </template>
            <template v-else>
              <template v-for="(itemsInner, key) in itemsFilter" :key="key">
                <div class="form-group  d-flex flex-sm-wrap flex-md-nowrap align-items-center solid justify-content-between mt-3">
                  <h4 class="m-0">{{key}}</h4>
                  <div class="buttons d-flex flex-sm-wrap flex-md-nowrap align-items-center justify-content-between">
                    <button-component v-if="getIsButtonVisible(itemsInner)" type="button" class="btn-primary justify-content-center btn-sm card-footer__btn white my-2 width-auto mx-2"
                                v-on:click="exportPdf(itemsInner)">Печать</button-component>                                    
                    <button-component type="button" class="btn-primary justify-content-center btn-sm card-footer__btn white my-2 width-auto"
                                    v-on:click="expand(key)">{{expanded[key] ? 'Свернуть' : 'Развернуть'}}</button-component>                                          
                  </div>   
                </div>
                <div v-if="expanded[key]">
                  <div v-for="item in itemsInner" v-bind:key="item.id">
                      <drop-down class="my-2" :label="item.serviceTypeName" :addClass="item.isRefuse ? 'refuse' : ''">
                          <div class="table-inner">
                              <table class="table table-custom border-light">
                                  <thead>
                                  <tr>
                                      <th width="50%">Поставщик</th>
                                      <th :style="{width: !item.isOrganizationChoose ? '20%' : '25%'}" >Условия</th>
                                      <th :style="{width: !item.isOrganizationChoose ? '20%' : '25%'}" >Договор</th>
                                      <th style="width: 10%" v-if="!item.isOrganizationChoose">Выбрать</th>
                                      <th v-if="modals.messenger.isAvailable">Мессенджер</th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  <tr v-for="org in filterOrg(item.organizations)" v-bind:key="org.id">
                                      <td><span @click.stop="showOrganization(org)" class="lras-link">{{org.name}}</span></td>
                                      <td class="text-center"><file-download :file="org.statementFile" icon-class="fas fa-info-circle" /></td>
                                      <td class="text-center"><file-download :file="org.contractFile" icon-class="fas fa-file" /></td>
                                      <td v-if="!item.isOrganizationChoose">
                                          <CustomCheckBox :id="'org_choose_' + item.id + '_' + org.id" :checked="false" v-model="org.isActive" @change="organizationChoose(item.id, org)" />
                                      </td>
                                      <td v-if="modals.messenger.isAvailable">
                                          <div class="messenger" @click="openMessenger(org.itemId)">
                                            <i class="far fa-comments"></i>
                                            <span :class="{'text-bold':org.unreadMessageCount > 0}">{{org.unreadMessageCount}}</span>
                                          </div>
                                      </td>
                                  </tr>
                                  </tbody>
                              </table>

                              <table class="table table-custom border-light">
                                  <thead>
                                  <tr>
                                      <th width="20%">Расписание</th>
                                      <th width="20%">Срок</th>
                                      <th width="20%">Факт исполнения</th>
                                      <th width="20%">Средняя оценка</th>
                                      <th width="20%" v-if="item.isOrganizationChoose">Отказ</th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  <tr>
                                      <td width="20%">{{ item.schedule }}</td>
                                      <td width="20%">{{ $moment.format(item.dateBegin, "DD.MM.YYYY") }} - {{
                                          $moment.format(item.dateEnd, "DD.MM.YYYY")
                                      }}</td>
                                      <td width="20%">
                                          <progress-bar @click.stop="showVisit(item)" :percent="item.percent"/>
                                      </td>
                                      <td width="20%" class="text-right">{{ item.markAverage }}</td>
                                      <td width="20%" v-if="item.isOrganizationChoose">
                                          <CustomCheckBox :id="'item_refuse_' + item.id" :checked="item.isRefuse" 
                                              :disabled="item.isRefuse"
                                              v-model="item.isRefuse" @change="sendRefuse(item)"   />
                                      </td>
                                  </tr>
                                  </tbody>
                              </table>
                          </div>
                      </drop-down>
                    </div>
                </div>
              </template>                
            </template>
        </div>
        <section class="modals">
            <modal-component v-if="modals.org.show">
                <org-modal @close="modals.org.show = false" :item="modals.org.currentOrg" />
            </modal-component>
            <modal-component v-if="modals.visit.show">
                <visit-modal @close="modals.visit.show = false" :items="modals.visit.current" />
            </modal-component>
            <modal-component v-if="modals.refuse.show">
                <refuse-with-comment  :imar-id="modals.refuse.imarId"
                    @close="cancelRefuse();"
                    @save="modals.refuse.show = false; loadList();"/>
            </modal-component>
            <modal-component v-if="modals.messenger.show" title="Мессенджер" class="modal-content--card"
                             @close="modals.messenger.show = false">
                <MessengerForm :filter="modals.messenger.filter"></MessengerForm>
            </modal-component>
        </section>
    </section>
</template>
<script>

import CustomCheckBox from "../../../common/ui/CustomCheckBox";
import DropDown from "../components/DropDown";
import ProgressBar from "../../../common/ui/progressBar";
import ModalComponent from "../../../common/ui/ModalComponent";
import OrgModal from "../components/OrgModal";
import VisitModal from "../components/VisitModal";
import API from '../api/imar'
import RefuseWithComment from "../components/RefuseWithComment";
import Constants from '@/common/constants'
import FileDownload from "@/common/components/FileDownload";
import HeaderSubComponent from "../../../common/components/HeaderSubComponent";
import MessengerForm from "../../messenger/components/MessengerForm";
import security from "@/common/mixins/security";
import ButtonComponent from "@/common/components/ButtonComponent"

export default {
    name: "imar",
    components: {
      MessengerForm,
      HeaderSubComponent,
      VisitModal, OrgModal, ModalComponent, ProgressBar, DropDown, CustomCheckBox, RefuseWithComment, FileDownload, ButtonComponent},
    mixins: [security],
    data() {
        return {
            refusal: false,
            performance: false,
            job: false,

            isLoading: false,
            items: [],

            modals: {
                refuse: {
                    show: false,
                    imarId: null
                },
                org: {
                    show: false,
                    currentOrg: null,
                },
                visit: {
                    show: false,
                    curent: null,
                },
              messenger: {
                isAvailable: false,
                filter: {
                  dialogType: null,
                  patientId: null,
                  journalImarOrganizationId: null
                },
                show: false
              }
            },
            expanded: {},
        }
    },
    created() {
      this.checkPermission(Constants.OrgServicesChat)
          .then((response) => {
            this.modals.messenger.isAvailable = response.data;
          });
        this.loadList();
    },
    methods: {
        loadList() {
            this.isLoading = true;
            API.getList().then(response => {
                this.items = response.data;                
                console.log(this.items, "------------ getList");
                this.isLoading = false;

            });
        },
        showOrganization(org) {
            this.modals.org.show = true;
            this.modals.org.currentOrg = org;
            return false;
        },
        organizationChoose(imarId, org) {
            var alertOptions = {
                title: 'Подтверждение',
                text: 'Вы действительно хотите заключить с выбранной организацией договор на оказание услуг?',
                confirmButtonText: 'Да',
                cancelButtonText: 'Нет',
                showCancelButton: true,
                icon: 'warning',
            };
            Constants.alert.fire(alertOptions).then((res) => {
                if (res.isConfirmed) {
                    API.chooseOrg(imarId, org.id).then(response => {
                        if(response.data.success)
                            this.loadList();   
                        else {
                            org.isActive = false;
                            Constants.alert.fire('Ошибка', response.data.message ? response.data.message : 'Произошла ошибка при выборе организации', 'error');
                        }
                    });          
                } else {
                    org.isActive = false;
                }
            });
        },
        filterOrg(orgList) {
            if(orgList.length == 1 || !orgList.some(el => el.isActive))
                return orgList;

            return orgList.filter(el => {
                return el.isActive;
            });
        },
        sendRefuse(el) {
            //Посылаем отказ по услуге
            var alertOptions = {
                title: 'Подтверждение',
                text: 'Вы действительно хотите отказаться от оказания услуги?',
                confirmButtonText: 'Да',
                cancelButtonText: 'Нет',
                showCancelButton: true,
                icon: 'warning',
            };
            Constants.alert.fire(alertOptions).then((res) => {
                if (res.isConfirmed) {
                    this.modals.refuse.show = true;
                    this.modals.refuse.imarId = el.id;        
                } else {
                    el.isRefuse = false;
                }
            });
        },
        cancelRefuse() {
            this.modals.refuse.show = false;
            //надо вернуть в изначальное состояние
            var el = this.items.find(x => x.id == this.modals.refuse.imarId);
            if(el) {
                el.isRefuse = false;
            }
        },
        showVisit(item) {
            this.modals.visit.show = true;
            this.modals.visit.current = item.visits;
        },
      openMessenger(id) {
        this.modals.messenger.filter = {dialogType: 3, patientId: null, journalImarOrganizationId: id};
        this.modals.messenger.show = true;
      },
      exportPdf(items) {
        if (items && items.length) {
          let journalRouteId = items[0].journalRouteId;
          API.exportPdf(journalRouteId);
        }
      },
      getIsButtonVisible(items) {
        return items && items.every(x => x.isConfirmed === true);
      },
      expand(key) {
        if (!this.expanded[key])
            this.expanded[key] = true;
        else
            this.expanded[key] = false;
      }, 
    },
    computed: {
        itemsFilter() {
            if(!this.items)
                return [];
            var res = this.items;
            var resReduced = res.reduce((grouped, item) =>{
                const key = item['journalRouteName']
                if (!grouped[key]) {
                    grouped[key] = [];
                }
                grouped[key].push(item);
                return grouped;                
            }, {})
            return resReduced;
        },
    },
}
</script>
<style lang="scss" scoped>
@import './src/assets/theme/default/colors';

.questions-link {
    padding: 12px 20px;
    font-weight: 600;
    color: $blue-light;
    background: #FFFFFF;
    box-shadow: 0px 2px 14px rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    text-decoration: none;
}

.lras-link {
    color: $blue-light;
    font-size: 16px;
    font-weight: 500;
    text-decoration: none;
    cursor: pointer;
}

.lras__list {
  padding: 24px;
  margin: 10px 24px 0 24px;
  border-radius: 24px;
  border: none;
  box-shadow: none;
  background-color: #fff;
}

.form-group {
  background-color: #F5F5FA;
  letter-spacing: 0.5px;
  padding: 0 12px;
}

.messenger {
  cursor: pointer;
  color: $blue-light;
  span {
    margin-left: 8px;
  }
}

@media (max-width:801px)  {
    .lras__list .form-group {
        display: block !important;
    }    
    .lras__list h4 {
        font-size: 1.2em;
    }
    .lras__list .buttons {
        justify-content: left!important
    }
}
@media (max-width: 767px){
    .lras__list{
        margin: 0px;
        .form-group:first-of-type{
            margin-top: 0px !important;
        }
    }
    .form-group{
        padding: 12px;
    }
    .dropdown{
        overflow: hidden;
    }
    .lras__list .buttons{
        margin-top: 12px;
        flex-wrap: wrap;
        gap: 12px;
        .btn-sm{
            margin: 0px !important;
        }
        button{
            width: 100%;
        }
    }
}
</style>